import useTranslations from '@/i18n/useTranslations';
import ArtlistImage from '@/shared-components/cards/components/ArtlistImage';

import './styles/ArtlistNotFound.css';

export default function ArtlistNotFound() {
  const t = useTranslations('common.profile.pages.artlist');

  return (
    <section className="artlist-not-found" aria-labelledby="artlist-not-found-title">
      <div className="artlist-not-found__header" aria-hidden="true">
        <ArtlistImage className="artlist-not-found__artlist-image" image="" />

        <div className="artlist-not-found__skeleton-content">
          <div className="artlist-not-found__skeleton artlist-not-found__skeleton--creator" />
          <div className="artlist-not-found__skeleton artlist-not-found__skeleton--full" />
          <div className="artlist-not-found__skeleton artlist-not-found__skeleton--partial" />
        </div>
      </div>

      <h1 id="artlist-not-found-title" className="artlist-not-found__title">
        {t('not_found.title')}
      </h1>
    </section>
  );
}
